import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ConversationStarterClickedEventProperties {
  message_text: string
  expert_id: string
}

export class ConversationStarterClickedEvent extends Event<
  ConversationStarterClickedEventProperties
> {
  static displayName = 'Conversation Starter Clicked'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
